// ToastNotification.js
import React, { useEffect, useState } from 'react';
import { Toast, ToastContainer, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const ToastNotification = ({ show, onClose }) => {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        if (show) {
            const interval = setInterval(() => {
                setProgress((prev) => (prev < 100 ? prev + 1 : 100));
            }, 50); // Adjust the speed as needed

            return () => clearInterval(interval);
        }
    }, [show]);

    return (
        <ToastContainer className="toast-container">
            <Toast show={show} onClose={onClose} delay={4000} autohide>
                <Toast.Header>
                    <div className="me-2 icon">
                        <FontAwesomeIcon icon={faSpinner} spin />
                    </div>
                    <strong className="me-auto">Download in Progress</strong>
                </Toast.Header>
                <Toast.Body>
                    Check your local storage for the folder.
                    <ProgressBar now={progress} className="progress mt-2" />
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default ToastNotification;
